const brightGreen300Color = '#01A54E';

export default brightGreen300Color;
